var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"settings":_vm.settings}},[_c('router-view',{staticClass:"section py-5",on:{"sectionUpdated":_vm.updateSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }